import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Routes } from 'app/services/routeService/routeService'
import { isNil } from 'ramda'
import { FormattedMessage } from 'react-intl'
import { useQueryClient } from '@tanstack/react-query'

import SubscriberPanel from 'app/main/subscribersV4/subscriberDetail/SubscriberPanel'
import useSubscriberDetail from 'app/main/subscribersV4/subscriberDetail/useSubscriberDetail'
import MessagespringLoading from 'app/componentV4/Loader/MessagespringLoading'
import { FormProvider } from './FormProvider'
import useLanguage from 'app/components/selector/useLanguage'
import { SUBSCRIBER_GROUPS_QUERY_KEY } from '../queries/useSubscriberGroupsQuery'

const SubscriberDetail = (props) => {
  const {
    match: {
      params: { subscriberId },
    },
    history,
  } = props

  const {
    state: { subscriber, isLoading, error, countries, isCountryLoading },
    onFetchSubscriberDetail,
    refetchData,
    getCountries,
    onLoading,
  } = useSubscriberDetail()
  const { items: languages, isLoading: isLanguageLoading } = useLanguage()
  const queryClient = useQueryClient()

  useEffect(() => {
    onFetchSubscriberDetail(subscriberId)
    getCountries()
  }, [])

  useEffect(() => {
    if (!isNil(error) && !isLoading) {
      history.push(Routes.subscribersV4())
    }
  }, [error])

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [SUBSCRIBER_GROUPS_QUERY_KEY],
    })
  }, [])

  return isLoading || !subscriber || isLanguageLoading || isCountryLoading ? (
    <div className="flex justify-center m-auto">
      <div>
        <MessagespringLoading />
        <div className="text-blue-950 mt-5">
          <FormattedMessage id="dataTable.pagination.loading" />
        </div>
      </div>
    </div>
  ) : (
    <FormProvider>
      <SubscriberPanel
        {...props}
        refetchData={refetchData}
        subscriber={subscriber}
        languages={languages}
        countries={countries}
        onLoading={onLoading}
      />
    </FormProvider>
  )
}

SubscriberDetail.propTypes = {
  route: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
}

export default SubscriberDetail
